export default __webpack_public_path__ + "static/media/Frame.2d6146f5.png";